import { createGlobalStyle } from "styled-components"

// export const primaryColor = "#39bc7d" // vert saint étienne
// export const secondaryColor = "#fe7a42" // orange hollande
export const primaryColor = "#0557a3" // bleu france
export const secondaryColor = "#f64135" // rouge france
export const darkGrey = "#1C1C1C"
export const medGrey = "#353535"
export const lightGrey = "#eee"
export const fontFamily = "Quicksand"
export const fontSizeM = "1.2rem"
export const fontSizeS = "1rem"

export const GlobalStyle = createGlobalStyle`

    :root {
        --maxWidth: 1280px;
        --white: #fff;
        --lightGrey: ${lightGrey};
        --medGrey: ${medGrey};
        --darkGrey: ${darkGrey};
        --black: #282828;
        --blue: #4169e1;
        --darkblue: #000b5e;
        --red: #bb0000;
        --darkred: #440909;
        --green: #317256;
        --darkgreen: #04400b;
        --grey: #686868;
        --orange: #ff7f01;
        --yellow: #ffe303;
        --purple: #820bbb;
        --pink: #ff3e96;
        --brown: #562e19;
        --transparent: rgba(255, 255, 255, 0.1);
        --primary: ${primaryColor}; 
        --secondary: ${secondaryColor};
        --fontXL: 2.5rem;
        --fontL: 1.5rem;
        --fontM: ${fontSizeM};
        --fontS: ${fontSizeS};
        --fontXS: 0.8rem;
    }

    * {
        box-sizing: border-box;
        margin: 0;
        font-family: ${fontFamily}, sans-serif;
    }

    body {
        margin: 0;
        padding: 0;

        h1 {
            font-size: 2.5rem;
            font-weight: 600;
            color: var(--lightGrey);
        }

        h3 {
            font-size: 1.5rem;
            font-weight: 600;
        }

        p {
            font-size: 1rem;
            color: var(--lightGrey);
        }
    }
`
